import {
  NIPT_SHORT_LIST_PROFESSIONALS_RESPONSE,
  NIPT_SHORT_LIST_PROFESSIONALS_FAILURE,
  NIPT_SHORT_LIST_PROFESSIONALS_REQUEST,
  NIPT_SHORT_LIST_PROFESSIONALS_UPDATE,
  NIPT_PROFESSIONALS_SHORT_UPDATE_FILTER
} from "../../actions/types";

const defaultKeywords = `NON-INVASIVE PRENATAL TESTING,CELL FREE DNA,PRENATAL TESTING,ANEUPLOIDY,NEWBORN SCREENING`;

const initialState = {
  isFetching: false,
  isMoreResult: true,
  isMoreResultLoading: false,
  professionals: [],
  error: false,
  isInitialScreen: true,
  keyword: defaultKeywords,
  size: 10,
  from: 0,
  activePage: 1,
  totalExperts: 0,
  terms: "",
  country: "",
  experts: [],
  university: [],
  activeSortItem: { value: "term_citation_count", label: "Total Related Citation" }
};

const setRequest = (state, action) => {
  const { terms = "", country = "", experts = [], university=[] } = action.payload;

  let keyword = terms.split(",")
  keyword = keyword.join(", ")
  return {
    ...state,
    isFetching: true,
    error: false,
    isInitialScreen: false,
    professionals: [],
    experts,
    country,
    terms,
    university,
    keyword: keyword?keyword:defaultKeywords
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    isInitialScreen: false,
    professionals: [],
    totalExperts: 0,
    activeSortItem: { value: "term_citation_count", label: "Total Related Citation" },
    terms: "",
    country: "",
    experts: [],
    university: []
  };
};

const setResponse = (state, action) => {
  let {
    experts = [],
    totalExperts = "-",
    activePage,
    activeSortItem
  } = action.payload;
  return {
    ...state,
    isFetching: false,
    error: false,
    professionals: experts,
    isInitialScreen: false,
    totalExperts,
    activePage,
    activeSortItem
  };
};

const updateProfessionals = (state, action) => {
  const { slectedItems, type } = action.payload;
  let newList = [...state.professionals];
  let totalExperts = state.totalExperts;
  if (type === "remove") {
    totalExperts  -= slectedItems.length;
    newList = newList.filter(l => slectedItems.indexOf(l.disambiguated_name)  === -1)  
  } else {
    newList = newList.map(l => {
      if (slectedItems.indexOf(l.disambiguated_name) !== -1) {
        l.shortListed = true;
      }

      return l;
    });
  }

  return {
    ...state,
    professionals: newList,
    totalExperts: totalExperts
  };
};

const updateFilter = (state, action) => {
  const { terms, country } = action.payload;
  return {
    ...state,
    terms,
    country
  };
};


export default (state = initialState, action) => {
  switch (action.type) {
    case NIPT_SHORT_LIST_PROFESSIONALS_RESPONSE:
      return setResponse(state, action);
      break;

    case NIPT_SHORT_LIST_PROFESSIONALS_FAILURE:
      return setFailure(state, action);
      break;

    case NIPT_SHORT_LIST_PROFESSIONALS_REQUEST:
      return setRequest(state, action);

    case NIPT_SHORT_LIST_PROFESSIONALS_UPDATE:
      return updateProfessionals(state, action);

    case NIPT_PROFESSIONALS_SHORT_UPDATE_FILTER:
      return updateFilter(state, action);

    default:
      return state;
      break;
  }
};
